"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Typography_1 = require("./Typography");
exports.default = Typography_1.default;
//# sourceMappingURL=index.js.map